export default "__VITE_ASSET__DHJwz8ZE__"